import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { getBasePath } from '@/utils/urlBase'
import indexPage from '../views/Index.vue'
import mobilePage from '../views/pages/Mobile.vue'
import illustrationPage from '../views/pages/Illustration.vue'
import arPage from '../views/pages/ARpage.vue'
import mapPage from '../views/pages/MAPpage.vue'
import qaPage from '../views/pages/QApage.vue'
import mangoGamePage from '../views/pages/MangoGamePage.vue'
import chinaberryGamePage from '../views/pages/ChinaberryGamePage.vue'
import soapberryGamePage from '../views/pages/SoapberryGamePage.vue'
import soapberryBraceletPage from '../views/pages/SoapberryBraceletPage.vue'

const routes = [

  {
    path: '/',
    name: 'home',
    component: indexPage
  }
  ,
  {
    path: '/mobile',
    name: 'mobile',
    component: mobilePage
  },
  {
    path: '/illustration',
    name: 'Illustration',
    component: illustrationPage
  },
  {
    path: '/ar',
    name: 'AR',
    component: arPage
  },
  {
    path: '/mappage',
    name: 'Map',
    component: mapPage
  },
  {
    path: '/qa',
    name: 'QA',
    component: qaPage
  },
  {
    path: '/mangogame',
    name: 'MangoGame',
    component: mangoGamePage
  },
  {
    path: '/chinaberrygame',
    name: 'ChinaberryGame',
    component: chinaberryGamePage
  },
  {
    path: '/soapberrygame',
    name: 'SoapberryGame',
    component: soapberryGamePage
  },
  {
    path: '/soapberrybracelet',
    name: 'SoapberryBracelet',
    component: soapberryBraceletPage
  },
  {
    // 這頁載入 TensorFlow.js（core+webgl backend+hand-pose-detection），會讓 bundle 大約多 10MB，
    // 只是拿來看偵測效果用的診斷工具，不是一般訪客會用到的頁面，所以用動態 import 讓 webpack
    // 把它切成獨立的 chunk，一般瀏覽這個網站不會多下載到這包東西，只有真的連到這個路徑才會載入
    path: '/handlandmarkdebug',
    name: 'HandLandmarkDebug',
    component: () => import('../views/pages/HandLandmarkDebugPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(getBasePath()),
  routes
})

export default router
